import * as R from 'ramda';

export const mapSummaryFromJson = R.compose(json => {
  return {
    total_balance: R.defaultTo('-', json['remaining_amount']),
    total_funding_amount: R.defaultTo('-', json['total_funding_amount']),
    disbursed_amount: R.defaultTo('-', json['blocked_funding_amount']),
    active_loans: R.defaultTo('-', json['total_active_loans']),
    fully_paid_loans: R.defaultTo('-', json['total_complete_loans']),
    pending_loan_count: R.defaultTo('-', json['total_pending_loans']),
    pending_loan_amount: R.defaultTo('-', json['total_pending_loans_amount'])
  };
}, R.defaultTo({}));
